import { inject, PLATFORM_ID } from '@angular/core';

import { Actions, ofType, createEffect } from '@ngrx/effects';
import * as metaActions from '../actions/meta.action';

import { tap } from 'rxjs/operators';
import { Meta, Title, MetaDefinition } from '@angular/platform-browser';
import { isPlatformBrowser } from '@angular/common';

export const setTitle$ = createEffect(
  (actions$ = inject(Actions), metaTitle = inject(Title)) => {
    return actions$.pipe(
      ofType(metaActions.SetTitle),
      tap(({ title }) => {
        metaTitle.setTitle(title);
      })
    );
  },
  { functional: true, dispatch: false }
);

export const setCanonical$ = createEffect(
  (actions$ = inject(Actions), meta = inject(Meta), platformId = inject(PLATFORM_ID)) => {
    return actions$.pipe(
      ofType(metaActions.SetCanonical),
      tap(({ url }) => {
        // Only manipulate DOM in browser environment
        if (!isPlatformBrowser(platformId)) {
          return;
        }

        // Remove existing canonical link
        const existingLink = document.querySelector('link[rel="canonical"]');
        if (existingLink) {
          existingLink.remove();
        }

        // Create new canonical link tag
        const link: HTMLLinkElement = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        link.setAttribute('href', url);
        document.head.appendChild(link);
      })
    );
  },
  { dispatch: false, functional: true }
);

export const setMeta$ = createEffect(
  (actions$ = inject(Actions), meta = inject(Meta)) => {
    return actions$.pipe(
      ofType(metaActions.SetTags),
      tap(({ properties }) => {
        const keys = Object.keys(properties);
        const data: MetaDefinition[] = keys.map(a => {
          const property = a;
          const content = properties[a];

          if (property === 'description') {
            return { name: property, content } as MetaDefinition;
          }

          return { property, content };
        });
        meta.addTags(data);
      })
    );
  },
  { functional: true, dispatch: false }
);
